/* eslint-disable */
// Support component names relative to this directory:
var instantSearchRequireContext = require.context('instant_search', true);
var sharedComponentsRequireContext = require.context('components', true);

var ReactRailsUJS = require('react_ujs');
ReactRailsUJS.useContexts([
  instantSearchRequireContext,
  sharedComponentsRequireContext,
]);
